import type { ReactElement } from 'react'
import type { FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { AlertTriangle } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { env } from '@/lib/env'

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps): ReactElement {
  const { t } = useTranslation('errors')
  const message = error instanceof Error ? error.message : String(error)

  return (
    <div
      role="alert"
      className="border-destructive/40 bg-destructive/5 m-4 flex flex-col items-start gap-3 rounded-lg border p-6"
    >
      <div className="text-destructive flex items-center gap-2">
        <AlertTriangle className="size-5" />
        <h2 className="text-base font-semibold">{t('boundary.title')}</h2>
      </div>

      <p className="text-muted-foreground text-sm">{t('boundary.description')}</p>

      {!env.isProduction && (
        <pre className="bg-muted text-muted-foreground max-h-48 w-full overflow-auto rounded-md p-3 text-xs">
          {message}
        </pre>
      )}

      <Button variant="secondary" size="md" onClick={resetErrorBoundary}>
        {t('boundary.reset')}
      </Button>
    </div>
  )
}
